import i18next from 'i18next'
import * as React from 'react'
import { InView } from 'react-intersection-observer'
import { DataLayer } from '../../../../utils/datalayer'
import { blockInviewHandler } from '../../../../utils/inview'
import { KnowledgeTeasersLayout } from '../knowledgeTeasers/knowledgeTeasersLayout'
import { KnowledgeTeasersData } from '../knowledgeTeasers/knowledgeTeasersState'

type KnowledgeTypeOverviewLayoutProps = {
  teasers: KnowledgeTeasersData
  paywalled: boolean
}

export const KnowledgeTypeOverviewLayout = (
  p: KnowledgeTypeOverviewLayoutProps
) => {
  const letterHasChildren = (letter: string) =>
    p.teasers.filter((article) => article.HeaderTitle.startsWith(letter))
      .length > 0
  const findFirstLetterWithChildren = letters.find(letter => letterHasChildren(letter))
  return (
    <>
      <nav
        className="pagination--az container--m gutter--m"
        aria-label={i18next.t('a11y:navLabelPagination')}
      >
        <div className="pagination__inner">
          <ul className="pagination__list">
            {letters.map((letter) => (
              !letterHasChildren(letter) ? (
                <li className="pagination__item" key={letter} aria-hidden="true">
                  <span className="button--ghost pagination__link disabled">
                    <span className="button__label">{letter}</span>
                  </span>
                </li>
              ) : (
                <li className="pagination__item" key={letter}>
                  <a
                    href={`#${letter}`}
                    className="button--ghost pagination__link"
                    onClick = {() => DataLayer.clickKnowledgeLetter(p.teasers[0].KnowledgeType, letter)}
                  >
                    <span className="button__label">{letter}</span>
                  </a>
                </li>
              )
            ))}
          </ul>
        </div>
      </nav>

      <InView
        as="section"
        threshold={0}
        triggerOnce={true}
        onChange={(isInView, entry) => blockInviewHandler(isInView, entry.target)}
        className="block knowledge"
      >
        <ol className="knowledge__inner container--m gutter--m">
          {(p.paywalled ? (findFirstLetterWithChildren != undefined ? [...findFirstLetterWithChildren] : ['A']) : letters).map(
            (letter) =>
              letterHasChildren(letter) && (
                <KnowledgeTeasersLayout
                  key={letter}
                  kind="knowledge-type-overview"
                  title={letter}
                  data={p.teasers
                    .filter((article) => article.HeaderTitle.startsWith(letter))
                    .sort((a, b) => a.HeaderTitle.localeCompare(b.HeaderTitle))
                    .slice(0, p.paywalled ? 8 : p.teasers.length)}
                />
              )
          )}
        </ol>
      </InView>
    </>
  )
}

const letters = [
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z',
]
